import { LocaleStartParams } from '@platform-frontend/transloco';

export interface ErrorAutostartParams extends LocaleStartParams {
  type: 'error';
  errorType: string;
}
